import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { CertificatesAnpr } from 'shell/models/certificates-anpr';
import { CertificatesAnprForm } from 'system/components/certificates-anpr/form';
import { DateTime } from 'luxon';
import { base64ToBlob } from 'shell/utils/base64-to-blob';

export const transformerCertificatesAnpr = (
  response: AxiosResponse<HttpResponse<CertificatesAnpr>>
): CertificatesAnprForm => {
  const data = response.data.payload;

  return {
    operatorCode: data.codiceOperatoreAnpr || '',
    operatorName: data.nomeOperatoreAnpr || '',
    code: data.codicePostazioneAnpr || '',
    alias: data.aliasCertificato || '',
    endValidityDate: data.dataFineValidita ? DateTime.fromISO(data.dataFineValidita) : null,
    startValidityDate: data.dataInizioValidita ? DateTime.fromISO(data.dataInizioValidita) : null,
    lastOperator: data.codiceOperatoreUltimoAggiornamento || '',
    password: data.password || '',
    contextLastUpdate: data.note || '',
    lastModifyDate: data.timestampUltimoAggiornamento
      ? DateTime.fromISO(data.timestampUltimoAggiornamento)
      : null,
    certificateUpload: {
      raw: data.certificato ? `data:application/octet-stream;base64,${data.certificato}` : '',
      file: data.certificato
        ? new File([base64ToBlob(data.certificato)], data.codicePostazioneAnpr)
        : null,
    },
  };
};
